import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { css, cx } from '@emotion/css';
import { observer } from 'mobx-react-lite';
import { getNumPages } from './utils';
import { DrawerThumbnailMultiPage } from './Thumbnails/DrawerThumbnailMultiPage';
import { useDrawerData } from './DrawerProvider';
export const DrawerThumbnailMultiBox = observer((props) => {
    const { asset, onClick, onDoubleClick, arrowOffset, numberOfColumns } = props;
    const { styleOptions, multiboxListAutoscrollOptions } = useDrawerData();
    const scrollRef = useRef(null);
    let id = '';
    if (!asset.data) {
        return null;
    }
    id = asset.data.id;
    const numPages = getNumPages(asset);
    const multiboxWrapperStyle = css `
        display: flex;
        flex-flow: wrap;
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hide;
        width: 100%;
        padding: ${styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.flexboxGap}px 0 ${styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.flexboxGap}px ${styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.flexboxGap}px;
        gap: ${styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.flexboxGap}px;
    `;
    const multiBoxWidth = numberOfColumns * styleOptions.thumbnailSize +
        styleOptions.flexboxGap * (numberOfColumns - 1) +
        styleOptions.flexboxGap * 0.5;
    const multiboxStyle = css `
        width: ${multiBoxWidth}px;
        display: flex;
        border-radius: 8px;
        box-shadow: 0 4px 20px #0000001a;
        border: 1px solid #dfdfdf;
        position: relative;
        margin-top: 10px;

        &:after,
        &:before {
            content: '';
            display: inline-block;
            position: absolute;
            width: 0;
            height: 0;
            vertical-align: top;
        }

        &:after {
            top: -10px;
            left: calc(${arrowOffset}% - 10px);
            z-index: 1;
            border: 10px solid transparent;
            border-top-width: 0;
            border-bottom-color: #dfdfdf;
        }

        &:before {
            top: -8px;
            left: calc(${arrowOffset}% - 8px);
            z-index: 2;
            border: 8px solid transparent;
            border-top-width: 0;
            border-bottom-color: white;
        }

        label: multibox;
    `;
    useEffect(() => {
        var _a;
        if (!numPages || !multiboxListAutoscrollOptions.isEnable) {
            return;
        }
        (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            behavior: 'smooth',
            block: multiboxListAutoscrollOptions.block,
        });
    }, [multiboxListAutoscrollOptions, numPages]);
    return (_jsx("div", Object.assign({ className: multiboxStyle, "data-testid": "drawer-multi-box" }, { children: _jsx("div", Object.assign({ ref: scrollRef, className: cx('multibox-drawer-thumbnail-list', multiboxWrapperStyle) }, { children: [...Array(numPages)].map((_, index) => {
                return (_jsx(DrawerThumbnailMultiPage, { asset: asset, onClick: onClick, onDoubleClick: onDoubleClick, pageNumber: index + 1 }, `${id}-page-${index + 1}`));
            }) })) })));
});
DrawerThumbnailMultiBox.displayName = 'DrawerThumbnailMultiBox';
//# sourceMappingURL=DrawerThumbnailMultiBox.js.map